export enum RecordingStatus {
	Processing = "PROCESSING",
	Ready = "READY",
}
